import React, { Component }from 'react';
import moment from 'moment';
import { formatTotal } from '../helpers';
import { 
  Button,
  ListGroup,
  ListGroupItem,
  Glyphicon,
  Panel
} from 'react-bootstrap';

class WorkoutListItem extends Component {
  render() {
    const { href, isActive, workout} = this.props;
    const timeStamp = moment(new Date(workout.timeStamp)).format('lll');
    return(
      <ListGroupItem 
        key={workout.key}
        active={isActive}
        href={href}
        onClick={() => this.context.router.push(`/workouts/${workout.key}`)}
      >
        {formatTotal(workout.total)}
        <span className="pull-right text-muted small">{timeStamp}</span>
      </ListGroupItem>
    );
  }
}

WorkoutListItem.contextTypes = {
  router: React.PropTypes.object
}

class WorkoutHistory extends Component {
  constructor(props) {
    super(props);
    this.renderWorkoutListItem = this.renderWorkoutListItem.bind(this);
  }

  renderWorkoutListItem(workout) {
    return(
      <WorkoutListItem key={workout.key} workout={workout} ></WorkoutListItem>
    );
  }

  render() {
    const { workouts } = this.props;
    const workoutListItems = Object.keys(workouts).reverse().map(key => this.renderWorkoutListItem(workouts[key]));
    
    const style = {
      marginTop: "-4px",
      marginRight: "-9px"
    };

    const header = (
      <div>
        <Button 
          style={style}
          className="pull-right" 
          bsSize="small"
          bsStyle="primary"
          onClick={(e) => this.props.createWorkout(e)}
        >
          <Glyphicon glyph="plus-sign" /> New
        </Button>
        Recent Workouts
      </div>
    );

    return(
      <Panel header={header}>
        <ListGroup fill>
          { workoutListItems }
        </ListGroup>
      </Panel>
    );
  }
}

WorkoutHistory.propTypes = {
  workouts: React.PropTypes.object.isRequired,
  createWorkout: React.PropTypes.func.isRequired
}

export default WorkoutHistory;


// WEBPACK FOOTER //
// ./src/components/WorkoutHistory.jsx